import Link from "next/link";
import React, { useContext, useEffect, useState } from "react";
import { FaWhatsapp } from "@react-icons/all-files/fa/FaWhatsapp";
import { AiOutlinePhone } from "@react-icons/all-files/ai/AiOutlinePhone";

import { Whatsapp } from "../api";
import { StoreContext } from "../../context/context";
import { useTranslation } from "../../context/TranslationContext";

const WhatsappButton = () => {
  const { wpMessage, phone } = useTranslation();
  const { currentRoutingTypeId, page } = useContext(StoreContext);
  const [data, setData] = useState(false);
  const [text, setText] = useState("");

  useEffect(() => {
    Whatsapp().then((e) => {
      setData(e.data);
    });
  }, []);

  useEffect(() => {
    if (currentRoutingTypeId == "ProductDetail")
      setText(wpMessage.replace("{Villa}", page.baslik));
    else setText("");
  }, [currentRoutingTypeId, page, wpMessage]);

  if (!data)
    return (
      <>
        <div className="py-2 flex flex-col items-center justify-center text-center">
          <FaWhatsapp size={30} />
          <span className="text-[0.625rem] font-medium">WhatsApp</span>
        </div>
        <div className="py-2 flex flex-col items-center justify-center text-center">
          <AiOutlinePhone size={30} />
          <span className="text-[0.625rem] font-medium">{phone}</span>
        </div>
      </>
    );

  return (
    <>
      <Link
        href={`https://wa.me/${data.data[0].phone}?text=${text}`}
        prefetch={false}
      >
        <a
          className="py-2 flex flex-col items-center justify-center text-center"
          target={"_blank"}
        >
          <FaWhatsapp size={30} />
          <span className="text-[0.625rem] font-medium">WhatsApp</span>
        </a>
      </Link>
      <Link href={"tel:" + data.phone}>
        <a>
          <div className="py-2 flex flex-col items-center justify-center text-center">
            <AiOutlinePhone size={30} />
            <span className="text-[0.625rem] font-medium">{phone}</span>
          </div>
        </a>
      </Link>
    </>
  );
};

export default WhatsappButton;
